export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/babel-loader/lib/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./VideoImage.vue?vue&type=template&id=4cf905be&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/VideoImage.vue?vue&type=template&id=4cf905be&scoped=true
// module id = 193
// module chunks = 0